;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface UserRoleHistory {
  role: string;
  action: 'added' | 'removed';
  changed_at: string;
  role_type: string;
}

export interface User {
  first_name: string;
  last_name: string;
  email: string;
  nationality_id?: number;
  /** Present on SSO `/users?role=employer` (and others); ids match admin country list. */
  country_id?: number | string;
  address?: string;
  zip?: string;
  city?: string;
  phone_country_id?: number;
  phone_number?: string;
  activated_at: string | null;
  /** When omitted by older responses, email delivery stays at the platform default (enabled). */
  can_receive_emails?: boolean;
  /** When omitted by older responses, in-app notifications stay at the platform default (enabled). */
  can_receive_notifications?: boolean;
  updated_at: string;
  created_at: string;
  id: number;
  roles: string[];
  role_history?: UserRoleHistory[];
  permissions: string[];
  new_app_access?: boolean;
  migrated_at?: string | null;
  activate_email_sent_at?: string | null;
  additional_employer?: boolean;
  two_factor_enabled?: boolean;
  google2fa_enabled?: boolean;
  two_factor_confirmed_at?: string | null;
}
